$( document ).ready(function() {
   
   /* Title formatting */

   //Replace middle word capital letters with line breaks
   function bb_givemeabreak(word) {
      //First letter
      first = word[0];
      word = word.substring(1);
      //Replace middle word capital letter with line break
      word = word.replace(/([A-Z+ÅÄÖ])/g, "<br>$1").toLowerCase();
      return first + word;
   }

   //Add linebrake before & in collection titles
   $('h2.title-with-bg-image span').each(function() {
      var text = $(this).html();
      text = text.replace('&amp; ', '&amp;&nbsp;');
      text = bb_givemeabreak(text);
      $(this).html(text);
   });
   
   /* Cart, added functionality */

   //Cart toggle
   $('.bb-cart').hover(function() { $('.bb-popup-cart').addClass("bb-cart-hover"); });
   $('.bb-cart').mouseleave(function() { $('.bb-popup-cart').removeClass("bb-cart-hover"); });
   $('.bb-popup-cart').hover(function() { $('.bb-popup-cart').addClass("bb-popup-cart-hover"); });
   $('.bb-popup-cart').mouseleave(function() { $('.bb-popup-cart').removeClass("bb-popup-cart-hover"); });

   /* Menus */
   
   //Mobile menu - expand first level on first interaction
   $('.bb-touch').click(function(e) {
      if ($(this).hasClass('active')) {
         return;
      } else if (!$(this).hasClass('open')) {
         e.preventDefault();
         $('.bb-touch').removeClass('open').removeClass('active');
         $(this).addClass('open');
      }
   });

   //Footer menu - add SM icons
   var html = '<li>';
   
   //Instagram
   html += '<a href="https://instagram.com/bonorochblad" aria-label="Instagram" target="_blank" rel="nofollow">';
   html += '<svg viewBox="0 0 511 511.9" xmlns="http://www.w3.org/2000/svg"><path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0"/><path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"/><path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"/></svg>';
   html += '</a> ';

   //Facebook
   html += '<a href="https://www.facebook.com/BonorOchBlad/" aria-label="Facebook" target="_blank" rel="nofollow">';
   html += '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 155.139 155.139;" xml:space="preserve"><g><path id="f_1_" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184 c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452 v20.341H37.29v27.585h23.814v70.761H89.584z"/></g></svg>';
   html += '</a>';

   html += '</li>';
   $('footer div.links-footer:last-child ul').append(html);
   
   /* Forms */

   //Disable anchor target on newslewtter form
   $('form.contact-form').each( function() {
      $(this).attr('action', '/contact');
   });

   /* Search form extended behaviour (added search elements are removed in liquid code) */
   $('#search-page-form').submit( function(e) {
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
      
      //Hide the form element so the extra attributes won't show
      $(this).find('#search_text').hide();

      //Add asterisks around and OR between words
      var searched = $(this).find('#search_text').val();
      var searchedArray = searched.split(' ');

      var searchedArrayLength = searchedArray.length;
      for (var i = 0; i < searchedArrayLength; i++) {
         searchedArray[i] = '*'+searchedArray[i]+'*';
         if( i > 0 ) {
            searchedArray[i] = ' OR '+searchedArray[i];
         }
      }
      
      searched = searchedArray.join();
      searched = searched.replace(/,/g, '')

      //submit the new search phrase
      $(this).find('#search_text').val( searched );
      localStorage.setItem("lastProductPage",1);
      this.submit();
   });

   /* Start page layout */

   // Add new parent element #1
   $('body.template-index .index-sections .shopify-section:nth-child(4)').after('<div id="bb_container_1" class="container"></div>').ready(function() {
      //Place two sections inside
      $('body.template-index .index-sections .shopify-section:nth-child(6)').detach().appendTo($('#bb_container_1'));
      $('body.template-index .index-sections .shopify-section:nth-child(6)').detach().appendTo($('#bb_container_1'));
   });

   // Add new parent element #2
   $('body.template-index .index-sections .shopify-section:nth-child(9)').after('<div id="bb_container_2" class="container"></div>').ready(function() {
      //Place three sections inside
      $('body.template-index .index-sections .shopify-section:nth-child(9)').detach().appendTo($('#bb_container_2'));
      $('body.template-index .index-sections .shopify-section:nth-child(9)').detach().appendTo($('#bb_container_2'));
      $('body.template-index .index-sections .shopify-section:nth-child(9)').detach().appendTo($('#bb_container_2'));
      console.log("Safari error tracing");
   });

   $('body.template-index .index-sections .shopify-section:nth-child(n+3)').addClass('container');

   /* BB Carousel */
   $('.bb-carousel').slick({
      infinite: false,
      slidesToShow: 6,
      slidesToScroll: 3,
      arrows: true,
      responsive: [
         {
            breakpoint: 1200,
            settings: {
               slidesToShow: 5,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 1080,
            settings: {
               slidesToShow: 5,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 992,
            settings: {
               slidesToShow: 4,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 3,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 520,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1
            }
         }
      ]
   });
   
   $('.bb-carousel-special').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 3,
      arrows: true,
      responsive: [
         {
            breakpoint: 1200,
            settings: {
               slidesToShow: 4,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 1080,
            settings: {
               slidesToShow: 4,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 992,
            settings: {
               slidesToShow: 3,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 3
            }
         },
         {
            breakpoint: 520,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1
            }
         }
      ]
   });
});

/* Sticky menu */
$(window).on('scroll', function() {
   var announcement_bar_height = 0;
   if( $('#shopify-section-announcement-bar').length ) {
      announcement_bar_height = $('#shopify-section-announcement-bar').height();
   }

   var y_scroll_pos = window.pageYOffset;
   var window_width = $(window).width();
   var offset_y = 1;
   
   if ( window_width > 992 ) {
      offset_y = 40;
   }

   offset_y += announcement_bar_height; //compensate for announcement bar if active

   if(y_scroll_pos > offset_y) {
      $('.header-wrapper').addClass('fixed');
      $('body').addClass('bb-sticky');
   }
   if(y_scroll_pos < offset_y) {
      $('.header-wrapper').removeClass('fixed');
      $('body').removeClass('bb-sticky');
   }
}).ready(function() {
   
});